import React from "react";
import type { FC } from "react";

import { createDisplayNameForContentElement } from "../../utils/getDisplayName";
import { createTestIdForContentElement } from "../../utils/getTestId";
import ContentText from "../Text/ContentText";

import type { OmitOfUnion } from "../../../../../types/react";
import type { ContentTextProps } from "../Text/ContentText";

const CONTENT_DOT_TEST_ID = createTestIdForContentElement("dot");

export type ContentDotProps = OmitOfUnion<
    ContentTextProps,
    | "children"
    | "maxLines"
    | "selfAlignmentY"
    | "textCase"
    | "underline"
    | "width"
    | "alignmentX"
    | "strikethrough"
    | "lineHeight"
    | "truncateStyle"
    | "quote"
    | "asList"
    | "italic"
>;

export const ContentDot: FC<ContentDotProps> = (props) => {
    return (
        <ContentText maxLines={1} {...props} data-tsid={CONTENT_DOT_TEST_ID}>
            •
        </ContentText>
    );
};

ContentDot.displayName = createDisplayNameForContentElement("Dot");

export default ContentDot;
